import { Heart, Target, Users } from "lucide-react";

export default function About() {
    return (
        <section id="om-os" className="relative py-24 md:py-32 overflow-hidden" data-testid="about-section">
            <div className="absolute inset-0 -z-10 bg-gradient-to-b from-white via-sky-50/40 to-white" />
            <div className="absolute right-0 top-20 -z-10 h-72 w-72 rounded-full bg-sky-100/60 blur-3xl" />
            <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-7">
                    <div className="inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-3 py-1 text-xs font-semibold text-slate-700">
                        <span className="h-1.5 w-1.5 rounded-full bg-sky-500" /> Om os
                    </div>
                    <h2 className="mt-5 font-display text-3xl md:text-5xl font-bold tracking-tight text-slate-900">
                        Skabt af folk der kender branchen.
                    </h2>
                    <div className="mt-6 space-y-4 text-base md:text-lg text-slate-600 leading-relaxed">
                        <p>
                            Vi har selv arbejdet i rengøringsbranchen — og kender frustrationen
                            ved Excel-ark, papirsedler og gamle systemer der ikke taler sammen.
                            Cleany er bygget for at samle hele driften ét sted, så I kan bruge
                            tiden på det vigtigste: jeres kunder.
                        </p>
                        <p>
                            Vores mission er enkel: at gøre det lige så nemt at drive et
                            rengøringsfirma som det er at sende en SMS.
                        </p>
                    </div>
                </div>
                <div className="lg:col-span-5 grid gap-4">
                    {[
                        { icon: Target, title: "Vores mission", text: "Fjern bureaukrati, så I kan fokusere på rent og glade kunder." },
                        { icon: Heart, title: "Vores filosofi", text: "Bygget med jer, ikke til jer. Hver feature kommer fra rigtige rengøringsfirmaer." },
                        { icon: Users, title: "Hvem vi er", text: "Et lille team af branchefolk og udviklere baseret i Danmark." },
                    ].map((c) => (
                        <div key={c.title} className="rounded-2xl bg-white border border-slate-200 p-6 flex gap-4 items-start" data-testid={`about-card-${c.title.toLowerCase().replace(/\s+/g, "-")}`}>
                            <div className="h-10 w-10 rounded-xl bg-sky-50 border border-sky-100 flex items-center justify-center text-sky-600 shrink-0">
                                <c.icon className="h-5 w-5" strokeWidth={1.75} />
                            </div>
                            <div>
                                <h3 className="font-display text-base font-semibold text-slate-900">{c.title}</h3>
                                <p className="mt-1 text-sm text-slate-600 leading-relaxed">{c.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
